export interface IssueView {
  q: string; category: string; status: '' | 'open' | 'in_progress' | 'resolved';
  mine: boolean; overdue: boolean; company?: number; unit?: string; view: 'list' | 'board'; team?: number | 'all';
  sort?: string;
}
export function parseIssueView(params: Record<string, string> = {}): IssueView {
  const company = Number(params.company);
  const team = Number(params.team);
  return {
    q: params.q || '', category: ['issue', 'customer_feedback', 'customer_log'].includes(params.category) ? params.category : '',
    status: ['open', 'in_progress', 'resolved'].includes(params.status) ? params.status as IssueView['status'] : '',
    mine: params.mine === '1', overdue: params.overdue === '1',
    company: Number.isSafeInteger(company) && company > 0 ? company : undefined,
    unit: Number.isSafeInteger(company) && company > 0 ? params.unit || undefined : undefined,
    view: params.view === 'board' ? 'board' : 'list',
    team: params.team === 'all' ? 'all' : Number.isSafeInteger(team) && team > 0 ? team : undefined,
    sort: /^(id|title|company|status|assignee|updated|next_action)_(asc|desc)$/.test(params.sort || '') && params.sort !== 'id_desc' ? params.sort : undefined
  };
}
export function serializeIssueView(view: IssueView): Record<string, string> {
  const params: Record<string, string> = {};
  if (view.q) params.q = view.q;
  if (view.category) params.category = view.category;
  if (view.status) params.status = view.status;
  if (view.mine) params.mine = '1';
  if (view.overdue) params.overdue = '1';
  if (view.company) { params.company = String(view.company); if (view.unit) params.unit = view.unit; }
  if (view.view === 'board') params.view = 'board';
  if (view.team !== undefined) params.team = String(view.team);
  if (view.sort && view.sort !== 'id_desc') params.sort = view.sort;
  return params;
}
